import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { FC, useState } from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import Colors from "~/constants/colors";
import Trans from "~/types/translationKeys";
import Icon from "../Icon";

import styles from "./SocialSharing.module.scss";

interface SocialSharingProps {
  className?: string;
  url: string;
  dataAos?: string;
}

const SocialSharing: FC<SocialSharingProps> = ({ url, className, dataAos }) => {
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.social_sharing, className)}
      data-aos={dataAos}
    >
      <p className={styles.text}>{t(Trans.share)}</p>
      <FacebookShareButton url={url}>
        <Image
          src="/social-media/facebook.svg"
          alt="Facebook logo"
          width={20}
          height={20}
        />
      </FacebookShareButton>
      <LinkedinShareButton url={url}>
        <Image
          src="/social-media/linkedin.svg"
          alt="LinkedIn logo"
          width={20}
          height={20}
        />
      </LinkedinShareButton>
      <TwitterShareButton url={url}>
        <Image
          src="/social-media/x.svg"
          alt="Twitter logo"
          width={20}
          height={20}
        />
      </TwitterShareButton>

      <div
        className="flex items-center cursor-pointer"
        onClick={() => {
          navigator.clipboard.writeText(url);
          setOpened(true);
          setTimeout(() => setOpened(false), 2000);
        }}
      >
        {opened ? (
          <span className={styles.copied}>{t(Trans.copied)}</span>
        ) : (
          <Icon name="link-21" color={Colors.GREY_500} />
        )}
      </div>
    </div>
  );
};

export default SocialSharing;
